import React from 'react'
import { logo,darkLogo } from '../../assets'
import { useStateContext } from '../../context/ContextProvider'
import { useTranslation } from 'react-i18next'
import { Section } from '.'
import {Link} from "react-router-dom"
import { navItems ,FotterText, socialMedia } from '../../constants'
 
function Fotter() {
   const {currentMode,currentDir} =useStateContext()
   const {t}=useTranslation()
  return (
   
   <div className=" w-full   bg-gradient-to-br from-back-primery to-back-secondary dark:from-back-darkprimery dark:to-back-darksecondary  items-center justify-center pt-16 xl:pt-20 ">
    <div className="container ">
<div className="mx-auto w-full p-4 py-6 lg:py-8">
        <div className="lg:flex justify-between ">
          <div className="mb-6 md:mb-0">
              <a href="/" className=" flex flex-col items-start justify-start gap-4 max-w-[24rem]">
                  <img src={currentMode === "Light" ? logo : darkLogo  } className="w-2/3" alt="FlowBite Logo" />
                <p className=" text-gray-500 dark:text-gray-400 font-kufi font-light text-lg md:body-2"> {currentDir === "ltr" ? FotterText.textEn : FotterText.textAr}</p>
              </a>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-10">
              <div>
                  <h2 className="mb-6 text-xl font-kufi font-bold md:h6 dark:text-tcolor-1 text-gray-900 uppercasetext-white">{t("Links")}</h2>
                  <ul className=" text-gray-500 dark:text-gray-400 font-kufi font-light text-lg md:body-3 ">
                    {navItems.map((item,index)=>(
     <li className="mb-4" key={index}>
     <Link to={item.link} className="hover:underline font-kufi">{currentDir === "ltr" ? item.titleEn :item.titleAr}</Link>
 </li>
                    ))}
                 
                    
                  </ul>
              </div>
              <div>
                  <h2 className="mb-6 text-xl font-kufi font-bold md:h6 text-gray-900 dark:text-tcolor-1 uppercasetext-white">{t("Follow us")}</h2>
                  <ul className=" text-gray-500 dark:text-gray-400 font-kufi font-light text-lg md:body-3 ">
                    {socialMedia.map((item,index)=>(
   <li className="mb-4 " key={index}>
   <a href={item.link} className="hover:underline flex flex-row items-center  gap-2 "> <span>{item.icon}</span>{currentDir === "ltr" ? item.titleEn :item.titleAr}  </a>
</li>

                    ))}
                   
                  </ul>
              </div>

         
          </div>
      </div>
      <hr className="my-6 dark:border-gray-200 sm:mx-auto border-gray-700 lg:my-8" />
      <div className="sm:flex sm:items-center sm:justify-between">
          <span className=" body-2 dark:text-gray-500 sm:text-center text-gray-400"> <a href="https://artcodey.com/" className="hover:underline"> {t("artcodey. All Rights Reserved © 2026.")}</a>
          </span>
       
      </div>
    </div>

</div>


   </div>


  )
}

export default Fotter